import store from '../../../../store';
export default function checkIfCanAdd() {
  let exists = false;
  let scopes = store.getters.userScopes;
  if (scopes.includes('user_account_add_all') || scopes.includes('user_account_add_company')) {
    exists = true;
  }
  return exists;
}
